
import Vue from 'vue'
import { IMenuItem } from '../store/state'
import MenuItem from './MenuItem.vue'
import { ITranslations, ICampaignWeb } from '../store/state'
import ExtraLinks from './ExtraLinks.vue'
import TopLinks from './TopLinks.vue'

interface MenuData {
    visible: boolean;
}
interface MenuMethods {
    toggleMenu(): void;
    openMenu(): void;
    closeMenu(): void;
    handleMenuKeydown(event: KeyboardEvent): void;
    getFocusableElements(): HTMLElement[];
}
interface MenuComputed {
    menuItems: IMenuItem[],
    translations: ITranslations,
    className: string,
    campaignWeb: ICampaignWeb,
    secondMenuItems: IMenuItem[],
}

interface MenuProps {
   
}

const component: Function = Vue.extend<MenuData, MenuMethods, MenuComputed, MenuProps>({
    name: 'Menu',
    data() {
        return { 
            visible: false
        }
    }, 
    computed: {
        menuItems() {
            return this.$store.getters.menuItems;
        },
        secondMenuItems() {
            return this.$store.getters.secondMenuItems;
        },
        translations() {
			return this.$store.getters.translations
		},
        className() {
            return this.$store.getters.className;
        },
        campaignWeb() {
            return this.$store.getters.campaignWeb;
        },
	},
    methods: {
        toggleMenu() {
            if (this.visible) {
                this.closeMenu();
            } else {
                this.openMenu();
            }
        },

        openMenu() {
            this.visible = true;
            document.body.classList.add("fixed");

            this.$nextTick(() => {
                const closeButton = this.$refs.menuClose as HTMLElement;

                if (closeButton) {
                    closeButton.focus();
                }
            });
        },

        closeMenu() {
            this.visible = false;
            document.body.classList.remove("fixed");

            this.$nextTick(() => {
                const menuToggle = this.$refs.menuToggle as HTMLElement;

                if (menuToggle) {
                    menuToggle.focus();
                }
            });
        },

        getFocusableElements() {
            const menuContainer = this.$refs.menuContainer as HTMLElement;

            if (!menuContainer) {
                return [];
            }

            const focusableSelector = [
                'a[href]',
                'button:not([disabled])',
                'input:not([disabled])',
                'select:not([disabled])',
                'textarea:not([disabled])',
                '[tabindex]:not([tabindex="-1"])'
            ].join(",");

            const elements = Array.prototype.slice.call(
                menuContainer.querySelectorAll(focusableSelector)
            ) as HTMLElement[];

            // Tar bort element som exempelvis ligger i en stängd undermeny
            // och därför inte är synliga.
            return elements.filter((element) => {
                return element.getClientRects().length > 0;
            });
        },

        handleMenuKeydown(event: KeyboardEvent) {
            if (event.key === "Escape") {
                event.preventDefault();
                this.closeMenu();
                return;
            }

            if (event.key !== "Tab") {
                return;
            }

            const focusableElements = this.getFocusableElements();
            const firstElement = focusableElements[0];
            const lastElement =
                focusableElements[focusableElements.length - 1];

            if (!firstElement || !lastElement) {
                event.preventDefault();

                const menuContainer =
                    this.$refs.menuContainer as HTMLElement;

                menuContainer.focus();
                return;
            }

            const activeElement = document.activeElement;

            if (event.shiftKey && activeElement === firstElement) {
                event.preventDefault();
                lastElement.focus();
            } else if (!event.shiftKey && activeElement === lastElement) {
                event.preventDefault();
                firstElement.focus();
            }
        }
    },
    components: {
		MenuItem,
        ExtraLinks,
        TopLinks,
	},
})

export default component
